import type { EarningsCalendarItem } from "./types.ts";
import { CALENDAR_EXTRACTION_VERSION } from "./version.ts";
import { isIsin } from "../gpw-companies/identity.ts";

export function isTrustedCalendarItem(item: EarningsCalendarItem) {
  const currentExtraction = item.id.startsWith("verified-") ||
    item.extractionVersion === CALENDAR_EXTRACTION_VERSION;
  let hasWebSource = false;
  try {
    hasWebSource = ["http:", "https:"].includes(new URL(item.sourceUrl).protocol);
  } catch {
    // Missing or malformed source links cannot support a confirmed date.
  }
  return currentExtraction &&
    ["planned", "changed", "published"].includes(item.status) &&
    item.confidence !== "low" &&
    isIsin(item.isin) &&
    Number.isInteger(item.fiscalYear) &&
    item.sourceType !== "secondary" && hasWebSource;
}
